<template>
  <v-layout>
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="30"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="period"
                label="Okres"
                prepend-icon="mdi-calendar-blank"
                readonly
                clearable
                v-bind="attrs"
                v-on="on"
                hide-details
            />
          </template>
          <v-date-picker
              v-model="periodRange"
              range
              show-adjacent-months
              :first-day-of-week="1"
              @change="onPeriodChanged"
          />
        </v-menu>
      </v-col>
      <v-col cols="12">
        <v-text-field
            class="mt-0 pt-0"
            v-model="debouncedFilters.userId"
            label="ID użytkownika"
            placeholder=" "
            :counter="10"
            :rules="rules.idFilter"
            hint="Tylko cyfry, bez #."
            persistent-hint
        />
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import {setDatatableFilters} from "@/utils/helpers";
import debounce from "debounce";
import formatters from "@/mixins/formatters";

export default {
  mixins: [
    formatters,
  ],
  data() {
    return {
      menu1: false,
      periodRange: [null, null],
      filterDebouncing: null,
      standardFilters: {
        planId: null, // TODO.
        periodFrom: null,
        periodTo: null,
      },
      debouncedFilters: {
        userId: '',
      },
      ignoreDebouncedFilters: true,
      rules: {
        textFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 2 || 'Wpisz co najmniej dwa znaki.'
          },
        ],
        idFilter: [
          (value) => {
            if (!value) {
              return true;
            }

            return value.length >= 1 || 'Wpisz co najmniej jeden znak.'
          },
        ],
      },
    };
  },
  created() {
    this.debouncedFilters.userId = this.$route.query.userId;

    this.$nextTick(() => {
      this.ignoreDebouncedFilters = false;
    });

    this.filterDebouncing = debounce(function () {
      this.filter();
    }, 500);
  },
  mounted() {
    this.$root.$on('getSubscriptionsFilters', (store) => {
      store.filters = {
        ...this.standardFilters,
        ...this.debouncedFilters,
      };
    });
  },
  beforeRouteUpdate(to, from, next) {
    next(); // Update the URL in address bar.
    this.debouncedFilters.userId = to.params.userId; // Store new user id in the local variable.
  },
  watch: {
    standardFilters: {
      handler() {
        setDatatableFilters.call(this);
        this.filter();
      },
      deep: true
    },
    debouncedFilters: {
      handler() {
        if (this.ignoreDebouncedFilters) {
          return;
        }

        setDatatableFilters.call(this);
        this.filterDebouncing();
      },
      deep: true
    },
  },
  computed: {
    period: {
      get() {
        return this.periodRange.filter((date) => {
          return null !== date;
        }).join(' - ');
      },
      set(dateRange) { // Called when user clicks "X" button to clear the text-field.
        if (null === dateRange) {
          dateRange = [null, null];
        }

        this.periodRange = dateRange;
        this.onPeriodChanged(dateRange); // Trigger the callback manually.
      }
    },
  },
  methods: {
    onPeriodChanged(dateRange) {
      this.menu1 = false;
      this.standardFilters.periodFrom = dateRange[0];
      this.standardFilters.periodTo = dateRange[1];
    },
    filter() {
      this.$root.$emit('loadSubscriptions', {
        filters: {
          ...this.standardFilters,
          ...this.debouncedFilters,
        },
        onSuccess: () => {
          this.$root.$emit('notify', {
            html: 'Filtrowanie zakończone.',
          });
        }
      });
    },
  }
}
</script>